import React, { useEffect, useState } from "react";
import {
  getCommissionReportAPI,
  getCommissionReportByUserAPI,
  resetCommissionReportByUserAPI,
} from "../service/AuthService";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import moment from "moment";
import { useSelector } from "react-redux";
export default function ComissionLenaDena() {
  const [data, setData] = useState();
  const [clientData, setClientData] = useState([]);
  const userData = useSelector((state) => state.account.userData);
  const navigate = useNavigate();
  const [filterData, setFilterData] = useState();
  const [hideSelect, setHideSelect] = useState(true);
  const [payload, setPayload] = useState({
    startDate: moment().subtract(180, "days"),
    endDate: moment(),
    userId: "",
    page: 0,
  });
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [size, setSize] = useState(1000);

  const [userName, setUserName] = useState('');

  const [gotData, setGotData] = useState(false);
  const getCommissionReport = async (_userName) => {
    const { response } = await getCommissionReportAPI(_userName?.toUpperCase());
    if (response.commissionReport?.length > 0) {
      setData(response.commissionReport);
      setClientData(response.commissionReport);
      setFilterData(response.commissionReport);
    }
    else {
      setData([])
      setClientData([])
      setFilterData([])
    }
  };

  const getCommissionReportByUser = async (clientId) => {
    const { response } = await getCommissionReportByUserAPI(clientId, {
      startDate: moment(payload.startDate).unix() * 1000,
      endDate: moment(payload.endDate).unix() * 1000,
      page: currentPage,
      currentPage,
      size,
      userId: payload.userId,
    });
    // if (code == 200) {
    setGotData(true);
    setData(response.commissionReport?.content);
    setFilterData(response.commissionReport?.content);
    setCurrentPage(response.commissionReport.number);
    setTotalPages(response.commissionReport.totalPages);
    setTotalElements(response.commissionReport.totalElements);
    setSize(response.commissionReport.size);
    // }
  };

  const resetComm = async (clientId) => {
    const { response, code } = await resetCommissionReportByUserAPI(clientId);
    getCommissionReport();
  };
  const applyFilter = async () => {
    await getCommissionReportByUser(payload.userId);
  };
  useEffect(() => {
    getCommissionReport();
  }, []);

  useEffect(() => {
    if (gotData) {
      getCommissionReportByUser(payload.userId);
    }
  }, [currentPage, size]);

  return (
    <div _ngcontent-ng-c3705319800="" className="content-wrapper">
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1> Commission Lena Dena</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb-item active">Commission Lena Dena</li>
              </ol>
            </div>
          </div>
        </div>
      </section>


      <div
        _ngcontent-ng-c2164784703=""
        className="content"
      >
        <div className="container-fluid">
          <div className="card">
            <div
              _ngcontent-ng-c2164784703=""
              className="card-header"
            >
              <div
                _ngcontent-ng-c2164784703=""
                className="row align-items-end"
              >
                {userData?.userType?.toLowerCase() !== "agent" &&
                  <>
                    {!payload.userId &&
                      <div
                        _ngcontent-ng-c2164784703=""
                        className="col-lg-4"
                      >

                        <div _ngcontent-ng-c2164784703="" className="input_block">
                          <label _ngcontent-ng-c2164784703="">Search Agent</label>
                          <div className=" d-flex align-items-center" style={{ gap: '3px' }}>
                            <input
                              _ngcontent-ng-c2164784703=""
                              type="text"
                              id="userName"
                              placeholder="Search Agent.."
                              value={userName}
                              onChange={(e) => {
                                setUserName(e.target.value);
                              }}
                              name="userName"
                              className="form-control ng-untouched ng-pristine ng-valid"
                            />
                            <button
                              _ngcontent-ng-c2164784703=""
                              type="button"
                              onClick={() => { setHideSelect(false); getCommissionReport(userName) }}
                              className="btn btn-primary"
                            >
                              Search
                            </button>
                            <button
                              _ngcontent-ng-c2164784703=""
                              type="button"
                              onClick={() => { getCommissionReport(null); setHideSelect(true); setUserName(''); }}
                              className="btn btn-primary"
                            >
                              Reset
                            </button>
                          </div>
                        </div>
                      </div>}

                  </>}

                {hideSelect && (
                  <>
                    <div
                      _ngcontent-ng-c2164784703=""
                      className="col-sm-12 col-md-6 col-lg-3"
                    >
                      <div
                        _ngcontent-ng-c2164784703=""
                        className="input_block position-relative"
                      >
                        <label _ngcontent-ng-c2164784703="">Select Client</label>
                        <Select
                          onChange={(e) => {
                            setPayload({ ...payload, userId: e.value });
                          }}
                          value={clientData
                            ?.map((item) => ({
                              value: item.clientId,
                              label: item.clientUsername,
                            }))
                            ?.find((option) => option.value === payload.userId) || null
                          }
                          options={clientData?.map((item) => ({
                            value: item.clientId,
                            label: item.clientUsername,
                          }))}
                        />
                      </div>
                    </div>
                    {payload.userId && (
                      <>
                        <div
                          _ngcontent-ng-c2164784703=""
                          className="col-lg-3" >
                          <div _ngcontent-ng-c2164784703="" className="input_block">
                            <label _ngcontent-ng-c2164784703="">Date From</label>
                            <input
                              _ngcontent-ng-c2164784703=""
                              type="date"
                              id="name"
                              name="name"
                              value={moment(payload.startDate).format("YYYY-MM-DD")}
                              onChange={(e) => {
                                setPayload({ ...payload, startDate: e.target.value });
                              }}
                              className="form-control ng-valid ng-dirty ng-touched"
                            />
                          </div>
                        </div>
                        <div
                          _ngcontent-ng-c2164784703=""
                          className="col-lg-3"
                        >
                          <div _ngcontent-ng-c2164784703="" className="input_block">
                            <label _ngcontent-ng-c2164784703="">Date To</label>
                            <input
                              _ngcontent-ng-c2164784703=""
                              type="date"
                              id="name"
                              value={moment(payload.endDate).format("YYYY-MM-DD")}
                              onChange={(e) => {
                                setPayload({ ...payload, endDate: e.target.value });
                              }}
                              name="name"
                              className="form-control ng-untouched ng-pristine ng-valid"
                            />
                          </div>
                        </div>
                      </>
                    )}

                    <div
                      _ngcontent-ng-c2164784703=""
                      className="col-lg-3"
                    >
                      <div _ngcontent-ng-c2164784703="" className="input_block d-flex gap-2 mt-3" style={{ gap: '5px' }}>
                        <button
                          _ngcontent-ng-c2164784703=""
                          type="button"
                          onClick={applyFilter}
                          className="btn btn-primary"
                        >
                          Submit
                        </button>
                        <button
                          _ngcontent-ng-c2164784703=""
                          type="button"
                          onClick={() => {
                            window.location.reload();
                          }}
                          className="btn btn-primary"
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </>)}

              </div>
            </div>
            <div _ngcontent-ng-c2164784703="" className="custom_table">
              <div _ngcontent-ng-c2164784703="" className="table-responsive">
                <table _ngcontent-ng-c2164784703="" className="table table-bordered table-striped dataTable no-footer dtr-inline"
                  style={{ marginTop: '0px' }}>
                  <thead _ngcontent-ng-c2164784703="">
                    <tr _ngcontent-ng-c2164784703="">
                      {gotData && (
                        <th
                          _ngcontent-ng-c2164784703=""
                          className="ng-star-inserted"
                        >
                          Date
                        </th>
                      )}
                      {!gotData && (
                        <th
                          _ngcontent-ng-c2164784703=""
                          className="ng-star-inserted"
                        >
                          Sr.No
                        </th>
                      )}
                      <th
                        _ngcontent-ng-c2164784703=""
                        className="ng-star-inserted"
                      >
                        {" "}
                        Name
                      </th>
                      {/**/}
                      {/**/}
                      {/**/}
                      <th _ngcontent-ng-c2164784703="">M.Comm.</th>
                      <th _ngcontent-ng-c2164784703="">S.Comm. </th>
                      <th _ngcontent-ng-c2164784703="">C.Comm.</th>

                      <th _ngcontent-ng-c2164784703="">T.Comm.</th>

                      {!gotData && (
                        <th>Action</th>
                      )}

                      <th _ngcontent-ng-c2164784703="">M.Comm.</th>
                      <th _ngcontent-ng-c2164784703="">S.Comm.</th>
                      <th _ngcontent-ng-c2164784703="">C.Comm.</th>

                      <th _ngcontent-ng-c2164784703="">T.Comm.</th>
                    </tr>
                  </thead>
                  <tbody
                    _ngcontent-ng-c2164784703=""
                    className="ng-star-inserted"
                  >
                    <tr _ngcontent-ng-c2164784703="">
                      <td _ngcontent-ng-c2164784703="" />
                      {/**/}
                      {gotData && <td _ngcontent-ng-c2164784703="" />}
                      {!gotData && <td _ngcontent-ng-c2164784703="" />}
                      <td
                        _ngcontent-ng-c2164784703=""
                        colSpan={4}
                        className="bg_green text-center"
                      >
                        <b _ngcontent-ng-c2164784703="" className="text-center">
                          PAYMENT RECEIVING FROM (MILA HE)
                        </b>
                      </td>

                      {!gotData && <td></td>}
                      <td
                        _ngcontent-ng-c2164784703=""
                        colSpan={4}
                        className="bg_red text-center">
                        <b _ngcontent-ng-c2164784703="" className="text-center">
                          PAYMENT PAID TO (DIYA HE)
                        </b></td>
                    </tr>
                    {
                      filterData
                        ?.sort((a, b) => {
                          if (gotData) {
                            const dateA = new Date(a.createdAt).getTime();
                            const dateB = new Date(b.createdAt).getTime();
                            return dateB - dateA; // newest first
                          } else {
                            const nameA = (a.clientUsername || a.eventName || "").toLowerCase();
                            const nameB = (b.clientUsername || b.eventName || "").toLowerCase();
                            return nameA.localeCompare(nameB); // A → Z
                          }
                        })
                        ?.map((item, index) => (
                          <tr key={item.index} className="ng-star-inserted">
                            {!gotData && <td _ngcontent-ng-c2164784703="">{index + 1}</td>}
                            {gotData && (
                              // <td>{moment(item?.createdAt).format("YYYY-MM-DD HH:mm")}</td>
                              <td style={{ whiteSpace: 'nowrap' }}>{moment(item?.createdAt).format("YYYY-MM-DD")}</td>
                            )}
                            <td>
                              <div className="reset_btn">
                                {item.clientUsername ? item?.clientUsername : item?.eventName}
                              </div>
                            </td>

                            <td>{parseFloat(item?.agentMatchCommission).toFixed(2)}</td>
                            <td>{parseFloat(item?.agentSessionCommission).toFixed(2)}</td>
                            <td>{parseFloat(item?.agentCasinoCommission).toFixed(2)}</td>
                            <td>
                              {parseFloat(
                                item.agentMatchCommission +
                                item.agentSessionCommission +
                                item.agentCasinoCommission
                              ).toFixed(2)}
                            </td>



                            {!gotData && (
                              <td>
                                <div className="d-flex justify-content-center align-items-center gap-2">

                                  <button
                                    onClick={() => {
                                      userData?.userType?.toLowerCase() === "agent" && resetComm(item.clientId)
                                    }}
                                    className="primary-background border-0 text-white text-xs px-3 py-1">
                                    Reset
                                  </button>
                                  <button onClick={() => {
                                    setPayload({ ...payload, userId: item.clientId });
                                    getCommissionReportByUser(item.clientId)
                                  }} className="primary-background border-0 text-white text-xs px-3 py-1">
                                    History
                                  </button>
                                </div>
                              </td>
                            )}

                            <td>{parseFloat(item?.clientMatchCommission).toFixed(2)}</td>
                            <td>{parseFloat(item?.clientSessionCommission).toFixed(2)}</td>
                            <td>{parseFloat(item?.clientCasinoCommission).toFixed(2)}</td>
                            <td>
                              {parseFloat(
                                item.clientCasinoCommission +
                                item.clientMatchCommission +
                                item.clientSessionCommission
                              ).toFixed(2)}
                            </td>
                          </tr>
                        ))}


                    {/**/}
                  </tbody>
                  {/**/}
                  <tfoot _ngcontent-ng-c2164784703="">
                    <tr _ngcontent-ng-c2164784703="" className="ng-star-inserted">
                      {gotData && <td _ngcontent-ng-c2164784703="" />}
                      {!gotData && <td _ngcontent-ng-c2164784703=""></td>}
                      <td _ngcontent-ng-c2164784703="">Total</td>
                      <td>
                        {parseFloat(
                          data?.reduce((a, b) => a + b.agentMatchCommission, 0)
                        ).toFixed(2)}
                      </td>
                      <td>
                        {parseFloat(data?.reduce((a, b) => a + b.agentSessionCommission, 0)).toFixed(2)}
                      </td>
                      <td>
                        {parseFloat(data?.reduce((a, b) => a + b.agentCasinoCommission, 0)).toFixed(2)}
                      </td>

                      <td>
                        {parseFloat(
                          data?.reduce(
                            (a, b) =>
                              a +
                              b.agentMatchCommission +
                              b.agentSessionCommission +
                              b.agentCasinoCommission,
                            0
                          )
                        ).toFixed(2)}
                      </td>
                      {!gotData && (
                        <td></td>)}
                      <td>
                        {parseFloat(
                          data?.reduce((a, b) => a + b.clientMatchCommission, 0)
                        ).toFixed(2)}
                      </td>
                      <td>
                        {parseFloat(
                          data?.reduce((a, b) => a + b.clientSessionCommission, 0)
                        ).toFixed(2)}
                      </td>
                      <td>
                        {parseFloat(
                          data?.reduce((a, b) => a + b.clientCasinoCommission, 0)
                        ).toFixed(2)}
                      </td>

                      <td>
                        {parseFloat(
                          data?.reduce(
                            (a, b) =>
                              a +
                              b.clientMatchCommission +
                              b.clientSessionCommission +
                              b.clientCasinoCommission,
                            0
                          )
                        ).toFixed(2)}
                      </td>
                    </tr>
                    {/**/}
                  </tfoot>

                  {/**/}
                </table>
                {gotData &&
                  <div className="col-sm-12 col-md-12 text-end">
                    <li>
                      Showing
                      {currentPage * size + 1} to{" "}
                      {currentPage * size + size > totalElements
                        ? totalElements
                        : currentPage * size + size}{" "}
                      of {totalElements} entries
                    </li>
                    <div
                      className="dataTables_paginate paging_simple_numbers"
                      id="example1_paginate"
                    >
                      <ul className="pagination justify-content-end align-items-center">
                        {/* Previous */}
                        <li
                          className={`page-item ${currentPage === 0 ? "disabled" : ""
                            }`}
                        >
                          <button
                            type="button"
                            className="page-link"
                            onClick={() => {
                              if (currentPage > 0) {
                                setCurrentPage(currentPage - 1);
                              }
                            }}
                            disabled={currentPage === 0}
                          >
                            Previous
                          </button>
                        </li>

                        {/* Current Page */}
                        <li className="page-item active">
                          <span className="page-link">
                            {currentPage + 1} / {totalPages}
                          </span>
                        </li>

                        {/* Next */}
                        <li
                          className={`page-item ${currentPage === totalPages - 1 ? "disabled" : ""
                            }`}
                        >
                          <button
                            type="button"
                            className="page-link"
                            onClick={() => {
                              if (currentPage < totalPages - 1) {
                                setCurrentPage(currentPage + 1);
                              }
                            }}
                            disabled={currentPage === totalPages - 1}
                          >
                            Next
                          </button>
                        </li>
                      </ul>

                    </div>

                  </div>}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/**/}
    </div>
  );
}